export const PRICING = {
    default: {
        monthly: {
            planName: "Interview Monthly Pass 🌟",
            description: "Use Interview Copilot for 6 Sessions each month.",
            title: "6 Copilot Sessions Each Month",
            item: "Interview Copilot® (60 Minutes/Session)"
        },
        payPerUse: {
            planName: "Starter Session ⚡",
            title: "Get 1 Copilot Session instantly",
            item: "Interview Copilot® (60 Minutes)"
        },
        quarterly: {
            planName: "FAANG Pack",
            description: "Use Interview Copilot for 18 Sessions each quarter.",
            title: "18 Copilot Sessions every 3 month",
            item: "Interview Copilot® (60 Minutes/Session)"
        }
    },
    assistant: {
        monthly: {
            planName: "Assistant Monthly Pass 🌟",
            description: "Use AI Assistant for 6 Sessions each month.",
            title: "6 Assistant Sessions Each Month",
            item: "AI Assistant® (60 Minutes/Session)"
        },
        payPerUse: {
            planName: "Starter Session ⚡",
            title: "Get 1 Assistant Session instantly",
            item: "AI Assistant® (60 Minutes)"
        },
        quarterly: {
            planName: "Pro Quarterly Pack",
            description: "Use AI Assistant for 18 Sessions each quarter.",
            title: "18 Assistant Sessions every 3 month",
            item: "AI Assistant® (60 Minutes/Session)"
        }
    }
};
